export default __webpack_public_path__ + "static/media/NTEX CLASS-9_SYLLABUS_2025-26.6c1259ab.pdf";